//import { mapActions, mapGetters, mapState } from "vuex";

export default {
	data: function() {
		return {
			//addToCartLoading: false,
		};
	},
	methods: {},
	computed: {
		disableAdd() {
			if (
				!this.activeProductDetails.PackageKey ||
				this.activeProductDetails.ShowFirstActivityOnly
			) {
				return false;
			} else if (
				this.totalActivityParticipants >= this.activeProductDetails.Participants
			) {
				return true;
			}
			return false;
		},
		entityHierarchyKey() {
			return this.$route.params.entityHierarchyKey
				? this.$route.params.entityHierarchyKey * 1
				: false;
		},
	},
};
